import './Filters.css';
import Slider from "@mui/material/Slider";
import {useEffect, useMemo, useState} from "react";
import CheckboxFilter from "./sub/CheckboxFilter/CheckboxFilter.jsx";
import {useLocation, useNavigate} from 'react-router-dom';
import {useMediaQuery} from "react-responsive";

const MIN_DISTANCE = 1;

/**
 * 🔧 Source of truth for branches (Rzęsy, Akcesoria, etc.)
 * If you already have this as `dropdownData` elsewhere, you can:
 *   1) import it here
 *   2) delete MENU_SOURCE
 *   3) replace `MENU_SOURCE` with your `dropdownData` in `buildNavFromMenu(...)`
 */
const MENU_SOURCE = [
    {
        name: "Rzęsy",
        link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?maincategory=${encodeURIComponent("Rzęsy")}`,
        categories: [
            { label: "Rzęsy do przedłużania", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Rzęsy do przedłużania")}`, items: [] },
            { label: "Pęsety do przedłużania", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Pęsety do przedłużania")}`, items: [] },
            { label: "Kleje do rzęs", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Kleje do rzęs")}`, items: [] },

            {
                label: "Preparaty",
                link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?subcategory=${encodeURIComponent("Preparaty")}`,
                items: [
                    { label: "Szampony", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Szampony")}` },
                    { label: "Cleanery", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Cleanery")}` },
                    { label: "Primery", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Primery")}` },
                    { label: "Przyśpieszacze do kleju", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Przyśpieszacze do kleju")}` },
                    { label: "Removery", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Removery")}` },
                ]
            },

            { label: "Taśmy i Płatki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Taśmy i Płatki")}`, items: [] },

            {
                label: "Artykuły jednorazowe",
                link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?subcategory=${encodeURIComponent("Artykuły jednorazowe")}`,
                items: [
                    { label: "Maseczki jednorazowe", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Maseczki jednorazowe")}` },
                    { label: "Rękawiczki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Rękawiczki")}` },
                    { label: "Podkłady kosmetyczne", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Podkłady kosmetyczne")}` },
                ]
            },

            { label: "Aplikatory i szczoteczki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Aplikatory i szczoteczki")}`, items: [] },

            {
                label: "Waciki",
                link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?subcategory=${encodeURIComponent("Waciki")}`,
                items: [
                    { label: "Waciki bezpyłowe", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Waciki bezpyłowe")}` },
                    { label: "Waciki bawełniane", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Waciki bawełniane")}` },
                ]
            },
        ]
    },
    {
        name: "Akcesoria",
        link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?maincategory=${encodeURIComponent("Akcesoria")}`,
        /**
         * ✅ Works the SAME WAY as “Rzęsy”.
         * - All direct children (leaf categories) are included.
         * - If you add subcategories with their own `items`, those subchildren will also
         *   automatically appear in the Kategorie filter for any Akcesoria page.
         */
        categories: [
            { label: "Lusterka", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Lusterka")}`, items: [] },
            { label: "Stojak na pęsety", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Stojak na pęsety")}`, items: [] },
            { label: "Pędzelki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Pędzelki")}`, items: [] },
            { label: "Podstawka na klej", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Podstawka na klej")}`, items: [] },
            { label: "Pojemniczki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Pojemniczki")}`, items: [] },
            { label: "Holdery", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Holdery")}`, items: [] },
            { label: "Poduszki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Poduszki")}`, items: [] },
            { label: "Tryskawki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Tryskawki")}`, items: [] },
            { label: "Wiatraczki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Wiatraczki")}`, items: [] },

            // Example of nested structure if you ever add it:
            // {
            //   label: "Organizacja stanowiska",
            //   link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?subcategory=${encodeURIComponent("Organizacja stanowiska")}`,
            //   items: [
            //     { label: "Kubeczki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Kubeczki")}` },
            //     { label: "Paletki", link: `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?kategoria=${encodeURIComponent("Paletki")}` },
            //   ]
            // },
        ]
    },
];

/** ───────────── Build NAV from menu (collect ALL children + subchildren) ───────────── */
function buildNavFromMenu(menu) {
    const nav = {};

    for (const section of menu) {
        const branch = section.name;
        const leafCats = [];
        const subcats = {};

        for (const cat of (section.categories || [])) {
            if (Array.isArray(cat.items) && cat.items.length > 0) {
                subcats[cat.label] = cat.items.map(i => i.label);
            } else {
                leafCats.push(cat.label);
            }
        }

        nav[branch] = { leafCats, subcats };
    }

    return nav;
}

const NAV = buildNavFromMenu(MENU_SOURCE);

const BRANCH_ALL_CATS = Object.fromEntries(
    Object.entries(NAV).map(([branch, def]) => {
        const subFlat = Object.values(def.subcats || {}).flat();
        const all = [...new Set([...(def.leafCats || []), ...subFlat])];
        return [branch, all];
    })
);

const ALL_LEAF_CATS = [...new Set(Object.values(BRANCH_ALL_CATS).flat())];

/** -------------------- URL <-> state helpers -------------------- */
function readFiltersFromURL(search) {
    const p = new URLSearchParams(search);

    const fix = (arr) => arr.map(s =>
        String(s ?? "")
            .replace(/\+/g, " ")
            .replace(/&nbsp;/g, " ")
            .replace(/\u00A0/g, " ")
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .replace(/\s+/g, " ")
            .trim()
    );

    const marka = fix(p.getAll('marka'));
    const kategoria = fix(p.getAll('kategoria'));
    const bestseller = (p.get('bestseller') || '').toLowerCase() === 'true';
    const newcollection = (p.get('newcollection') || '').toLowerCase() === 'true';
    const promotion = ((p.get('promocje') || p.get('promocja') || '').toLowerCase()) === 'true';

    const nazwa = (p.get('nazwa') || '').replace(/\+/g, ' ').replace(/\s+/g, ' ').trim();

    const maincategory = (p.get('maincategory') || '').trim();
    const subcategory  = (p.get('subcategory')  || '').trim();

    return { marka, kategoria, bestseller, newcollection, promotion, nazwa, maincategory, subcategory };
}

function buildSearchFromFilters(filters) {
    const params = new URLSearchParams();

    const mc = (filters.maincategory || '').trim();
    const sc = (filters.subcategory  || '').trim();
    if (mc) params.set('maincategory', mc);
    if (sc) params.set('subcategory',  sc);

    [...new Set([...(filters.marka || [])])]
        .sort((a,b) => a.localeCompare(b))
        .forEach(m => params.append('marka', m));

    // ALWAYS keep kategoria in URL (even when main/sub exist)
    [...new Set([...(filters.kategoria || [])])]
        .sort((a,b) => a.localeCompare(b))
        .forEach(k => params.append('kategoria', k));

    if (filters.bestseller)    params.set('bestseller', 'true');
    if (filters.newcollection) params.set('newcollection', 'true');
    if (filters.promotion)     params.set('promocje', 'true');

    const name = (filters.nazwa || '').trim();
    if (name) params.set('nazwa', name);

    const qs = params.toString();
    return qs ? `/produkty?${qs}` : `/produkty`;
}

function shallowEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}

/** Resolve branch ("Rzęsy" / "Akcesoria") from URL filters. */
function resolveBranch(filters) {
    const { maincategory, subcategory, kategoria } = filters;

    if (maincategory && NAV[maincategory]) return maincategory;

    if (subcategory) {
        const viaSub = Object.keys(NAV).find(b => NAV[b]?.subcats?.[subcategory]);
        if (viaSub) return viaSub;
    }

    if (Array.isArray(kategoria) && kategoria.length) {
        for (const b of Object.keys(NAV)) {
            const set = new Set(BRANCH_ALL_CATS[b]);
            if (kategoria.some(k => set.has(k))) return b;
        }
    }

    return null;
}

/** Build Kategorie list for the current context. */
function useContextualCategories(filters) {
    return useMemo(() => {
        const branch = resolveBranch(filters);
        const { kategoria, subcategory, maincategory } = filters;

        if (branch) {
            // ✅ Same behaviour for both branches:
            // show ALL children + subchildren of the resolved branch.
            return { categories: BRANCH_ALL_CATS[branch], hide: false, branch };
        }

        const hasHierarchy = !!(maincategory || subcategory);

        // Hide on pure leaf landing with a single known leaf
        if (!hasHierarchy &&
            Array.isArray(kategoria) &&
            kategoria.length === 1 &&
            ALL_LEAF_CATS.includes(kategoria[0])) {
            return { categories: [], hide: true, branch: null };
        }

        // Default: show all leaves across branches
        return { categories: ALL_LEAF_CATS, hide: false, branch: null };
    }, [filters]);
}

export default function Filters({
                                    priceRangeDraft,
                                    setPriceRangeDraft,
                                    applyPriceRange,
                                }) {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery({ maxWidth: 992 });

    const [brands] = useState(["Lume Lashes", "Oh OCHI Brand", "Staleks", "SCULPTOR","Lash Academy"]);
    const [specialOffers] = useState(["Bestsellery", "Nowa kolekcja", "Promocje"]);

    // APPLIED (URL-driven) vs DRAFT (mobile)
    const [filtersApplied, setFiltersApplied] = useState(() => readFiltersFromURL(location.search));
    const [filtersDraft, setFiltersDraft] = useState(() => readFiltersFromURL(location.search));

    useEffect(() => {
        const fromURL = readFiltersFromURL(location.search);
        if (!shallowEqual(filtersApplied, fromURL)) setFiltersApplied(fromURL);
        if (!shallowEqual(filtersDraft, fromURL)) setFiltersDraft(fromURL);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    useEffect(() => {
        const target = buildSearchFromFilters(filtersApplied);
        const current = `${location.pathname}${location.search || ""}`;

        // Don't redirect if we're on a clean category path with no active filters
        const isCleanPath = location.pathname.startsWith('/produkty/');
        const hasActiveFilters =
            filtersApplied.marka.length > 0 ||
            filtersApplied.kategoria.length > 0 ||
            filtersApplied.bestseller ||
            filtersApplied.newcollection ||
            filtersApplied.promotion ||
            filtersApplied.nazwa ||
            filtersApplied.maincategory ||
            filtersApplied.subcategory;

        if (!isCleanPath && current !== target) navigate(target, { replace: true });
        if (isCleanPath && hasActiveFilters && current !== target) navigate(target, { replace: true });
    }, [filtersApplied]);

    // Which state powers the UI
    const activeFiltersForUI = isMobile ? filtersDraft : filtersApplied;

    // Context (branch) detection
    const { categories, hide: baseHideKategorie, branch } = useContextualCategories(activeFiltersForUI);

    // In Akcesoria branch we still hide the Brand filter
    const hideBrand = branch === "Akcesoria";

    // PRICE SLIDER
    const handleChange = (event, newValue, activeThumb) => {
        if (!Array.isArray(newValue)) return;
        if (activeThumb === 0) {
            setPriceRangeDraft([
                Math.min(newValue[0], priceRangeDraft[1] - MIN_DISTANCE),
                priceRangeDraft[1],
            ]);
        } else {
            setPriceRangeDraft([
                priceRangeDraft[0],
                Math.max(newValue[1], priceRangeDraft[0] + MIN_DISTANCE),
            ]);
        }
    };

    const handleChangeCommitted = (event, newValue) => {
        if (!Array.isArray(newValue)) return;
        let [minV, maxV] = newValue;
        if (maxV - minV < MIN_DISTANCE) {
            if (event?.target?.dataset?.index === "0") {
                minV = Math.min(minV, maxV - MIN_DISTANCE);
            } else {
                maxV = Math.max(maxV, minV + MIN_DISTANCE);
            }
        }
        const committed = [minV, maxV];
        setPriceRangeDraft(committed);
        if (!isMobile) applyPriceRange(committed);
    };

    // MOBILE: Apply + Reset
    const applyAllMobile = () => {
        setFiltersApplied(filtersDraft);
        applyPriceRange(priceRangeDraft);

        const target = buildSearchFromFilters(filtersDraft);
        navigate(target, { replace: true });

        // Wait for next tick to let React Router update URL first
        setTimeout(() => {
            window.location.reload();
        }, 50);
    };

    const resetDraftMobile = () => {
        setFiltersDraft(filtersApplied);
    };

    // Which setter + value do children use?
    const filtersForChildren = isMobile ? filtersDraft : filtersApplied;
    const setFiltersForChildren = isMobile ? setFiltersDraft : setFiltersApplied;

    return (
        <div id='filters-container'>
            <span id='products-label-1'>FILTRUJ WEDŁUG</span>

            <div id='filter-price' className='product-filters'>
                <span id='price-label-1'>Cena</span>
                <span id='price-label-2'>{priceRangeDraft[0]} zł – {priceRangeDraft[1]} zł</span>
                <div id='price-slider-container'>
                    <Slider
                        min={1}
                        max={1000}
                        value={priceRangeDraft}
                        onChange={handleChange}
                        onChangeCommitted={handleChangeCommitted}
                        disableSwap
                        sx={{
                            width: '85%',
                            color: "#3A0E1B",
                            "& .MuiSlider-thumb": {
                                width: 20,
                                height: 20,
                                backgroundColor: "#3A0E1B",
                                borderRadius: 1,
                                transition: "none",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                "&:hover, &.Mui-focusVisible, &:active": { boxShadow: "0 2px 8px rgba(0,0,0,0.25)" },
                            },
                            "& .MuiSlider-rail": { height: '3px' },
                            "& .MuiSlider-track": { height: '1px' }
                        }}
                    />
                </div>
            </div>

            {/* BRAND — hidden in Akcesoria branch */}
            {!hideBrand && (
                <div id='filter-brand' className='product-filters'>
                    <CheckboxFilter
                        array={brands}
                        label={'Marka'}
                        setFilters={setFiltersForChildren}
                        filters={filtersForChildren}
                    />
                </div>
            )}

            {/* KATEGORIE — shows ALL children + subchildren for the resolved branch (Rzęsy or Akcesoria) */}
            {/*{!baseHideKategorie && categories.length > 0 && (*/}
            {/*    <div id='filter-turn' className='product-filters'>*/}
            {/*        <CheckboxFilter*/}
            {/*            array={categories}*/}
            {/*            label={'Kategorie'}*/}
            {/*            setFilters={setFiltersForChildren}*/}
            {/*            filters={filtersForChildren}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*)}*/}

            <div id='filter-offers' className='product-filters'>
                <CheckboxFilter
                    array={specialOffers}
                    label={'Oferty specjalne'}
                    setFilters={setFiltersForChildren}
                    filters={filtersForChildren}
                />
            </div>

            {/* MOBILE APPLY BAR */}
            {isMobile && (
                <div id="filters-apply-bar">
                    <button
                        type="button"
                        className="filters-reset-btn"
                        onClick={resetDraftMobile}
                        aria-label="Wyczyść zmiany filtra (przywróć do zastosowanych)"
                    >
                        Reset
                    </button>
                    <button
                        type="button"
                        className="filters-apply-btn"
                        onClick={applyAllMobile}
                        aria-label="Zastosuj filtry"
                    >
                        Zastosuj filtry
                    </button>
                </div>
            )}
        </div>
    );
}
